/**
 * SubformulaTitleAndExpression — half-width title + expression preview (header row)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Input } from '@/components/ui/form/input';

import SubformulaExpressionSnippet from './SubformulaExpressionSnippet';

export interface SubformulaTitleAndExpressionProps {
  name: string;
  onNameChange: (next: string) => void;
  expression: string;
}

const SubformulaTitleAndExpression: FC<SubformulaTitleAndExpressionProps> = ({
  name,
  onNameChange,
  expression,
}) => (
  <div className="grid min-h-8 min-w-0 flex-1 grid-cols-1 gap-2 sm:grid-cols-2">
    <Input
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      placeholder="Subformula title"
      className="h-8 min-w-0 text-sm font-medium"
      aria-label="Subformula title"
    />
    <SubformulaExpressionSnippet expression={expression} />
  </div>
);

export default SubformulaTitleAndExpression;
